module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/QRlogoBlue.83fd53c29f9aded35db1ebada202f097.svg";